<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Prozess-Flow</p>

      <h2 class="presentation-page__title">Vom Erstkontakt bis zur laufenden Anlage</h2>

      <p class="presentation-page__text">
        Fünf Schritte, klar verteilt — vier bis acht Monate von der Anfrage zur Inbetriebnahme.
      </p>

      <div class="presentation-page__group-cards presentation-page__group-cards--five">
        <article v-for="step in steps" :key="step.number" class="presentation-page__group-card">
          <div
            class="presentation-page__group-card-body presentation-page__group-card-body--process"
          >
            <div
              :class="[
                'presentation-page__group-card-step',
                `presentation-page__group-card-step--${step.accent}`,
              ]"
            >
              {{ step.number }}
            </div>

            <h3 class="presentation-page__group-card-title">{{ step.title }}</h3>

            <p class="presentation-page__group-card-partner">{{ step.partner }}</p>

            <p class="presentation-page__group-card-text">{{ step.text }}</p>
          </div>
        </article>
      </div>

      <p class="presentation-page__caption">
        Erstkontakt → Inbetriebnahme: typ. 4–8 Monate → Laufzeit 20–30 Jahre
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage09',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      steps: [
        {
          number: 1,
          accent: 'brand-primary',
          title: 'Kontakt',
          partner: 'Solveen',
          text: 'Anfrage, Erstgespräch, Bedarfsklärung über Webformular oder Partner.',
        },
        {
          number: 2,
          accent: 'brand-secondary',
          title: 'Bewertung',
          partner: 'ReTIS',
          text: 'Datenerfassung, Dach-/Standortprüfung, Wirtschaftlichkeitsberechnung.',
        },
        {
          number: 3,
          accent: 'brand-teal',
          title: 'Struktur',
          partner: 'e way',
          text: 'Vertragsmodell wählen: Kauf, Pacht, Mieterstrom oder Investor.',
        },
        {
          number: 4,
          accent: 'brand-secondary',
          title: 'Bau',
          partner: 'e way',
          text: 'Planung, Genehmigung, Installation, Netzanschluss — schlüsselfertig.',
        },
        {
          number: 5,
          accent: 'brand-primary',
          title: 'Betrieb',
          partner: 'e way + ReTIS',
          text: 'Monitoring, Wartung, Abrechnung — über 20+ Jahre, vollständig digital.',
        },
      ],
    };
  },
};
</script>
